import { Button, message } from 'antd';
import React from 'react';
import PhotosViewer from '../../components/PhotosViewer/PhotosViewer';
import PartnerApi from '../../functions/api/partner/PartnerApi';

export default class CustomerViewButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      detailUser: '',
    };
    this.toggle = this.toggle.bind(this);
  }

  async toggle() {
    const { record } = this.props;
    const [...images] = record.procedureImages;

    if (!images) {
      message.error('Chưa upload');
      return;
    }

    this.setState({
      images: await this.convertBookDocumentToArray(images),
      isOpen: true,
    });
  }

  convertBookDocumentToArray = async (images) => {
    const procs = await PartnerApi.getProcedures();

    return images.map((image) => {
      const pr = procs.find((p) => p.proc_id === image.proc_id);
      return {
        src: image.user_img_url,
        thumbnail: image.user_img_url,
        caption: pr.proc_name,
      };
    });
  };

  handleClose = () => {
    this.setState({
      isOpen: false,
    });
  };

  render() {
    const { isOpen, images } = this.state;
    return (
      <>
        <Button size="small" onClick={this.toggle}>
          Hồ sơ
        </Button>
        {isOpen && (
          <PhotosViewer
            onClose={this.handleClose}
            imgs={images}
            showThumbnails
            isOpen
          />
        )}
      </>
    );
  }
}
